var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("部署 Instance")]),_c('p',[_vm._v("每个 Application 都有自己的代码库。部署 Instance 的过程就是去代码库拉取指定分支的代码，合并配置文件，安装或者更新虚拟环境，重启 Instance 实例。")])])])])
}]

export { render, staticRenderFns }